import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumber } = CommonParameters;

export const assistance: IMcAppType = {
  name: "assistance",
  path: "/my/assistance",
  parameters: {
    properties: { accountNumber },
  },
  description: "Payment assistance options for a given account number",
  navFlow: NavFlow.STANDARD,
  title: "Payment assistance",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "assistance",
    customerType: CustomerType.kraken,
  },
};
